import {IReportAction, IReportState} from 'interfaces'
import {SET_REPORT} from 'redux/actions/report-action'

const initialState: IReportState = {
  data: [],
  totalRecordCount: 0,
  pageNumber: 1,
  pageSize: 10,
}

const reducer = (state = initialState, action: IReportAction) => {
  switch (action.type) {
    case SET_REPORT:
      return action.payload

    default:
      return state
  }
}

export default reducer
